import { showMessage, MessageType } from "react-native-flash-message";


export const alertMessage = (title:string,description:string,type:MessageType = "info") => {
 
  showMessage({
    message: title,
    description,
    type,
    duration:8000,
    hideOnPress: false,
    textStyle: {
      fontSize: 17,

    },
    titleStyle: {
      fontSize:20
    }

  });
};
